import { GraduationCap, Library } from 'lucide-react';
import { Navigate } from 'react-router';
import type { ModuleDefinition } from '../../app/modules';
import { learningRoutes } from './learning/routes';
import { registryRoutes } from './registry/routes';

/**
 * Процеси, регламенти, знання й навчання (М8).
 * Два розділи з власними вкладками:
 *  — «Процеси й регламенти» (/kb/registry/…): реєстр процесів L0–L5, документи й життєвий цикл регламентів,
 *    ознайомлення, питання й рішення, суперечності, посадові папки, словник, статті Бази знань, запити на зміну;
 *  — «Навчання» (/kb/learning/…): моє навчання, каталог курсів, програвач уроку, тести, редактор курсів,
 *    призначення й звіти, перевірка відповідей, імпорт з Google Класу, маршрути й допуски, довідки канбанів.
 * Читання доступне всім працівникам (область users:read); зміни — за правами, які перевіряє сервер.
 */
const kbModule: ModuleDefinition = {
  key: 'kb',
  label: 'Процеси й знання',
  icon: Library,
  basePath: '/kb',
  scope: 'users:read',
  order: 50,
  nav: [
    { to: '/kb/registry', label: 'Процеси й регламенти', icon: Library },
    { to: '/kb/learning', label: 'Навчання', icon: GraduationCap },
  ],
  routes: [{ index: true, element: <Navigate to="registry" replace /> }, ...registryRoutes, ...learningRoutes],
};

export default kbModule;
